module.exports = __webpack_public_path__ + "img/riba_logo.a3e87365.png";